module.exports = new __parcel__URL__("add-global-field.8d5e8843.gif").toString();